module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nav_home":"Home","nav_participants":"Participants","nav_settings":"Settings"},"sv":{"nav_home":"Hem","nav_participants":"Deltagare","nav_settings":"Inställningar"}}')
  delete Component.options._Ctor
}
